<template>
    <div class="container-medium well m-auto mt-8 pt-5 px-5 pb-0">
        <div
            v-for="(setting, indexSetting) in settings"
            :key="indexSetting"
            class="dinlineb valign-top span_3 px-6 pb-6 clear-first-last-space col-4"
        >
            <h3 class="mt-0 pb-1 bb-1">{{ setting.label }}</h3>
            <ul class="m-0">
                <li
                    v-for="(sub, indexSub) in setting.sub"
                    :key="indexSub"
                    class="settings-home__list"
                >
                    <router-link v-if="sub.vueRouting" :to="sub.url" class="black-link">
                        {{ sub.label }}</router-link
                    >
                    <a v-else :href="sub.url" class="black-link">{{ sub.label }}</a>

                    <CompassFlag
                        v-if="sub.flag"
                        :label="sub.flag.label"
                        :size="sub.flag.size"
                        :beta="sub.flag.beta"
                        class="settings-home__flag"
                    />
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
const settingsStore = createNamespacedHelpers('settingsStore');
export default {
    computed: {
        ...settingsStore.mapGetters({
            settings: 'getSettings',
        }),
    },
};
</script>

<style lang="scss" scoped>
.settings-home {
    &__list {
        align-items: center;
        display: flex;
        margin-bottom: var(--spacing-1);
    }
    &__flag {
        margin-left: var(--spacing-0);
    }
}
</style>
